module.exports = __webpack_public_path__ + "img/huanjing.b9c85801.png";